module.exports = __webpack_public_path__ + "static/media/ic_folder_white_36px.27fdc074.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ic_folder_white_36px.svg
// module id = 250
// module chunks = 0